import { useSearch, useSnowplowTracking } from '@eti/providers';
import type React from 'react';
import { useEffect, useState } from 'react';
import { collectFlightsAndPassengersContextData } from '../../../../common/tracking/snowplow/snowplowUtils';
import type { SelectedTripData } from './useSelectedTrip';

export interface UseSnowPlowTrackingProps {
  category: string;
  action: string;
  label: string;
}

export interface UseSnowPlowTrackingResponse {
  setSelectedTripDataForSnowPlow: React.Dispatch<React.SetStateAction<SelectedTripData | null>>;
}

export default function useSnowPlowTracking(props: UseSnowPlowTrackingProps) {
  const [selectedTripDataForSnowPlow, setSelectedTripDataForSnowPlow] =
    useState<SelectedTripData | null>(null);
  const { currentSearchData } = useSearch();
  const { isSnowplowTrackingEnabled, updateSnowplowContextData, sendTrackEvent } =
    useSnowplowTracking();

  useEffect(() => {
    if (isSnowplowTrackingEnabled && selectedTripDataForSnowPlow && currentSearchData?.routes) {
      updateSnowplowContextData({
        ...collectFlightsAndPassengersContextData(currentSearchData, selectedTripDataForSnowPlow),
      });

      sendTrackEvent(props);
    }
  }, [
    isSnowplowTrackingEnabled,
    currentSearchData,
    selectedTripDataForSnowPlow,
    sendTrackEvent,
    updateSnowplowContextData,
    props,
  ]);

  return { setSelectedTripDataForSnowPlow };
}
